import { Link } from '@hover/blueprint';
import React from 'react';

import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

const MAIN_CONTENT_ID = 'main';

const SkipLink = () => {
  const t = useTranslate(TranslationNamespace.COMMON);

  return (
    <Link
      _focus={{
        clipPath: 'unset',
        margin: 'auto',
        overflow: 'visible',
        top: 0,
      }}
      backgroundColor="neutral.0"
      clipPath="rect(1px, 1px, 1px, 1px)"
      href={`#${MAIN_CONTENT_ID}`}
      left="50%"
      overflow="hidden"
      padding="0.5rem"
      position="fixed"
      textAlign="center"
      top="-100%"
      transform="translateX(-50%)"
      zIndex="9999"
    >
      {t('skipToContent')}
    </Link>
  );
};

export { MAIN_CONTENT_ID, SkipLink };
